module.exports = __webpack_public_path__ + "static/media/pa.9f011e77.svg";